var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"title":_vm.$route.name}},[_c('div',{staticClass:"expande-horizontal wrap"},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.getTickets),function(ticket){return [_c('v-list-item',{key:ticket._id},[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(" "+_vm._s(ticket.title)+" ")])],1)],1)]})],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }